import React from "react";
import WidgetsRenderByAlignment from "./widgets-render-by-alignment";
import ThemeWrap from "./themes";
import WidgetInfo from "./widget-info";

const WidgetsRenderByTheme = ({ theme, widgets, from, to }) => {
    return (
        <ThemeWrap theme={theme}>
            <WidgetsRenderByAlignment widgets={widgets} from={from} to={to} />
        </ThemeWrap>
    );
};

const WidgetsRenderRoot = ({ widgets }) => {
    let lastTheme = "";
    let pointer = 0;

    let results = [];

    for (let index = 0; index < widgets.length; index++) {
        const widget = widgets[index];
        const { renderTheme: widgetTheme } = WidgetInfo.get(widget);
        const isFirstIndex = index === 0;
        const isLastIndex = index === widgets.length - 1;

        if (isFirstIndex) lastTheme = widgetTheme;

        if (lastTheme !== widgetTheme) {
            results.push(
                <WidgetsRenderByTheme
                    key={results.length + 1}
                    theme={lastTheme}
                    widgets={widgets}
                    from={pointer}
                    to={index - 1}
                />
            );
            lastTheme = widgetTheme;
            pointer = index;
        }

        if (isLastIndex) {
            results.push(
                <WidgetsRenderByTheme
                    key={results.length + 1}
                    theme={lastTheme}
                    widgets={widgets}
                    from={pointer}
                    to={index}
                />
            );
        }
    }

    return results;
};

export default WidgetsRenderRoot;
